module.exports = __webpack_public_path__ + "img/section8_bottom.a437482e.png";